window._ = require('lodash');

/*
 |--------------------------------------------------------------------------
 | Load popper.js dependency and the Bootstrap jQuery plugin
 |--------------------------------------------------------------------------
 |
 | Provides support for JavaScript based Bootstrap features such as modals and tabs.
 |
 */

try {
 window.Popper = require('popper.js').default;
 require('bootstrap');
}
catch (e) {
}

/*
 |--------------------------------------------------------------------------
 | Load axios HTTP library
 |--------------------------------------------------------------------------
 |
 | Issue requests to Laravel back-end. This library automatically handles sending
 | the CSRF token as a header based on the value of the "XSRF" token cookie.
 |
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
